<div class="link-taskbar">
    @if (settings()?.showViewInMap) {
        <div class="link-button" (click)="navigateToMapDwelling()">Vis i evKart</div>
    }
    @if (settings()?.showGetLandRegistrationReport) {
        <div class="link" (click)="navigateToMapDwelling()">Grunnboksutskrift</div>
        <div class="link" (click)="navigateToMapDwelling()">Historisk grunnboksutskrift</div>
    }
    @if (settings()?.showGetCadastreReport) {
        <div class="link-button" (click)="navigateToMapDwelling()">Matrikkelutskrift</div>
    }
</div>
